import { atom } from 'jotai'
import { CellId } from 'sierra-client/views/v3-author/table/multi-select/types'

export const tableCellMultiSelectionAtom = atom<CellId[]>([])
